<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="상품후기 조회"
      desc="등록된 게시글들의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <!-- 후기 적립금 사용 -->
    <div style="margin-bottom:1.5rem" v-if="point_setting.review_enable">
      <point-payment-popup :review_list="reviewList" :point_setting="point_setting"></point-payment-popup>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 nextPageName="nopage"
                 @check="clickCheckBox"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="showcaseCheckArr[props.idx]!==undefined"
          :checkedVal.sync="showcaseCheckArr[props.idx].value"></lp-check-bool>
      </div>

      <div slot="first_img" slot-scope="props">
        <div style="display: inline-block; text-align: center"
             :style="thumbImgField(props.item.img)" v-if="props.item.img"></div>
      </div>

      <div slot="product" slot-scope="props" style="cursor:pointer;text-decoration:underline">
        <span @click="newTab(props.item.product_id)">{{ props.item.product }}</span>
      </div>

      <div slot="title" slot-scope="props" style="cursor:pointer;text-decoration:underline">
        <div class="flex-center">
          <div @click="$router.push(getPath(`product/review/create?id=${props.item.id}`))">{{ props.item.title }}</div>
          <i class="material-icons" style="margin-left:8px;font-size:20px"
             v-if="props.item.imgs.length>0">{{ props.item.imgs.length === 1 ? 'image' : 'collections' }}</i>
        </div>
      </div>


      <div slot="comment_status" slot-scope="props" style="width: 120px; margin: auto;">
        <span v-if="props.item.comment_author"
              class="unselect"
              style="text-decoration: underline"
              @click="routerPush(`create?id=${props.item.id}`)">답변 완료</span>
        <span v-else>답변 전</span>
      </div>

      <div slot="comment_reg" slot-scope="props" style="width: 120px; margin: auto;">
        <button v-if="props.item.comment_author"
                class="button is-grey cancel"
                @click.stop.prevent="clickAnswer(props.item.id)">답변 수정</button>
        <button v-if="!props.item.comment_author"
                class="button state-btn review-make-comment"
                @click="clickAnswer(props.item.id)">답변 달기</button>
      </div>

      <div slot="delete" slot-scope="props">
        <button class="button half is-danger" @click.stop.prevent="deleteReview(props.item)">삭제</button>
      </div>
    </admin-table>
  </div>
</template>

<script>
  import moment from 'moment'
  import ListMixin from '@/mixins/ListMixin'
  import PointPaymentPopup from "../point/components/PointPaymentPopup";
  import LpCheckBool from "../../module/common/LpCheckBool";

  export default {
    name: 'ProductReviewList',
    components: {LpCheckBool, PointPaymentPopup},
    mixins: [
      ListMixin
    ],

    data() {
      return {
        qnaItem:{
          id: 0,
          comment: '',
        },
        point_setting: {
          review_enable: false
        }
      };
    },

    created() {
      this.init();

      this.$axios.get('admin/point/setting').then(res=>{
        this.point_setting = res.data;

        // 후기 적립금 사용일 경우
        if(this.point_setting.review_enable) {
          if(!find(this.tableData, 'eng_name', 'checkspot')) {
            this.tableData.splice(0, 0, {
              eng_name: 'checkspot',
              ko_name: '',
              width: '50px'
            })
          }
          if(!find(this.tableData, 'eng_name', 'save_point')) {
            this.tableData.splice(8, 0, {
              eng_name: 'save_point',
              ko_name: '적립금',
              width: '80px'
            })
          }
        } else {
          if(find(this.tableData, 'eng_name', 'checkspot')) {
            let idx = this.tableData.findIndex(item => item.eng_name === 'checkspot');
            removeIndex(this.tableData, idx);
          }
          if(find(this.tableData, 'eng_name', 'save_point')) {
            let idx = this.tableData.findIndex(item => item.eng_name === 'save_point');
            removeIndex(this.tableData, idx);
          }
        }
      })
    },
    computed: {
      reviewList() {
        let id_list = this.getCheckedArr();
        let review_list = this.tableItems.filter(item => {
          return id_list.indexOf(item.id) > -1;
        })
        return review_list;
      }
    },
    methods: {
      init () {
        let path = this.$route.path.split('/').reverse()[0];
        this.initializing(`product_review_${path}`, 'product/review');
        this.nowTime = moment().format('YY-MM-DD');
        if(path === 'new') {
          this.filtered.reply = 'true';
        }
      },
      getDataFromServer() {
        this.getData();
      },
      newTab(id){
        window.open(this.getPath(`product/create?id=${id}`));
      },
      // 답변 달기
      clickAnswer(id){
        this.$router.push(this.getPath('product/review/create?id='+id));
       /* this.qnaItem = undefined;
        this.qnaItem = {
          id: id,
          comment: ''
        };
        this.$axios.get(this.getUrl('product/review/'+id)).then(res=>{
          if(res.status===200){
            this.qnaItem = res.data;

            let value = {
              qnaItem: this.qnaItem,
              url: 'product/review/'+this.qnaItem.id,
              paramName: 'comment'
            };
            this.$store.commit('openModal', {type:'modal-inquiry-answer',value:value})
          }
        })*/
      },

      clickConfirm(idx) {
        // 서버에 확인 상태 전송
        this.$axios.post(this.getUrl('product/review/'+ idx)).then(res => {
          if(res.status===200){
            this.getData();
          }
        });
      },

      deleteReview(item) {
        let value = {
          id: item.id,
          url: 'product/review/',
          title: '후기를 삭제하시겠습니까?'
        }
        this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
      }

    }
  };
</script>

<style lang="stylus" type="stylus" scoped>

  .tr-whole-border th {
    padding: 12px 6px;
  }

  .many-field-tr td {
    padding: 6px;
  }

  .lp-form-type {
    color: #787878;
    display: table-cell;
    font-size: 0.8rem;
  }

  .table-cell {
    text-align: left;
    width: 100%;
  }
</style>
